import showEmailEditor from '@/functions/emailEditor'

export default [
    {
        path: `/r/people`,
        component: () => import('@/pages/people/index.vue')
    },
    {
        path: `/people/view/:personId`,
        component: () => import('@/pages/people/index.vue')
    },
    {
        path: `/people/view/:personId/notes`,
        component: () => import('@/pages/people/index.vue')
    },
    {
        path: `/people/:personId/notes`,
        component: () => import('@/pages/people/index.vue'),
        meta: {
            isVue: true,
            feature: 'vue-people',
            sideNav: 'person',
            roles: ['person_read_notes']
        }
    },
    {
        // added to support react urls. We cant remove this when the React is no longer used and the backend generating vue urls by default.
        path: `/people/view/:personId/tags`,
        component: () => import('@/pages/people/index.vue')
    },
    {
        path: `/people/:personId/tags`,
        component: () => import('@/pages/people/Person.vue'),
        meta: {
            isVue: true,
            feature: 'vue-people',
            sideNav: 'person',
            roles: ['tags']
        }
    },
    {
        path: `/people/view/:personId/message`,
        component: () => import('@/pages/people/Person.vue'),
        meta: {
            isVue: true,
            feature: 'vue-2way-messaging',
            sideNav: 'person'
        }
    },
    {
        path: `/people`,
        component: () => import('@/pages/people/index.vue'),
        children: [
            {
                path: `archives`,
                component: () => import('@/pages/people/index.vue')
            }
        ]
    },
    {
        path: `/people/saved`,
        component: () => import('@/pages/people/Saved.vue'),
        meta: {
            isVue: true,
            feature: `vue-people`,
            sideNav: `people`
        }
    },
    ...(showEmailEditor()
        ? [
              {
                  path: `/people/filter`,
                  component: () => import('@/pages/people/index.vue')
              }
          ]
        : [
              {
                  path: `/people/filter`,
                  component: () => import('@/components/people/sms/SmsEditorModal.vue')
              }
          ])
]
